import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FileType } from '../models/files.model';
import { Evento } from 'src/assets/proto-ts/evento';
import { FindMyCache } from 'src/app/pages/tools/utils/utils.component';

@Injectable({
  providedIn: 'root',
})
export class UtilService {
  private apiServerUrl = environment.loganConfig.url;

  constructor(private http: HttpClient) {}
  headers = new HttpHeaders().set('Content-Type', 'multipart/form-data');
  requestOptions: Object = {
    headers: this.headers,
    reportProgress: true,
    responseType: 'json',
  };

  headersSendToDev = new HttpHeaders().set('Content-Type', 'application/json');
  requestOptionsheadersSendToDev: Object = {
    headers: this.headersSendToDev,
    responseType: 'text',
    withCredentials: true,
  };

  public getSerialDump(seriais: string): Observable<String[]> {
    return this.http.post<String[]>(
      `${this.apiServerUrl}/api/v1/getSerialDump`,
      seriais
    );
  }

  public addDump(seriais: string, timeToDump: string): Observable<String[]> {
    return this.http.post<String[]>(
      `${this.apiServerUrl}/api/v1/addDump/` + timeToDump,
      seriais
    );
  }
  public prepareTextToDump(
    serial: string,
    supplier: string
  ): Observable<String[]> {
    return this.http.post<String[]>(
      `${this.apiServerUrl}/api/v1/prepareTextDump`,
      { serial: serial, supplier: supplier }
    );
  }
  public getDump(serial: string) {
    window.open(this.apiServerUrl + '/api/v1/getDump/' + serial);
  }

  public getCacheLora(serial: string[]): Observable<any> {
    return this.http.post<any[]>(
      `${this.apiServerUrl}/api/v1/loraCache`,
      {
        serial,
      },
      { withCredentials: true }
    );
  }

  public getLoraIdStatus(serial: string[]): Observable<any> {
    return this.http.post<any[]>(
      `${this.apiServerUrl}/api/v1/getLoraIdStatus`,
      { serial },
      { withCredentials: true }
    );
  }
  public insertLoRaCache(seriais: string): Observable<any> {
    return this.http.post<any>(
      `${this.apiServerUrl}/api/v1/insertLoraCache`,
      seriais,
      { withCredentials: true }
    );
  }

  public getUF(): Observable<String[]> {
    return this.http.get<String[]>(`${this.apiServerUrl}/api/v1/getUF`);
  }

  public getCity(uf: string): Observable<String[]> {
    return this.http.get<String[]>(`${this.apiServerUrl}/api/v1/getCity/${uf}`);
  }

  public generateEvent(event: string): Observable<any> {
    return this.http.post<string>(
      `${this.apiServerUrl}/api/telemetria/simulator`,
      event,
      { withCredentials: true }
    );
  }

  public sendPacketsToDEV(events: string[], port: number): Observable<any> {
    return this.http.post<string>(
      `${this.apiServerUrl}/api/telemetria/sendPacketsToDEV/${port}`,
      events,
      this.requestOptionsheadersSendToDev
    );
  }

  public getLastPosition(list: any): Observable<string> {
    return this.http.post(
      `${this.apiServerUrl}/api/telemetria/lastpositionJson/v2`,
      list,
      { withCredentials: true, responseType: 'text' }
    );
  }

  public deviceNearby(
    lat: number,
    lng: number,
    radius: number
  ): Observable<String[]> {
    return this.http.post<String[]>(
      `${this.apiServerUrl}/api/v1/devicesNearby`,
      { lat: lat, lng: lng, radius: radius },
      { withCredentials: true }
    );
  }

  public createFileIccid(
	username : string,
	userId : number
	) : Observable<any>{
    return this.http.post<JSON>(
      `${this.apiServerUrl}/files/createFileCsv/serialICCID`,
      { username: username, userId: userId },
      { withCredentials: true }
    );
  }

  public requestFilesIccid() : Observable<any>{
    return this.http.get<JSON>(
      `${this.apiServerUrl}/files/requestFilesCsv/serialICCID`,
      { withCredentials: true }
    );
  }

 public downloadFileCSV(id: string): Observable<Blob> {
  return this.http.get(`${this.apiServerUrl}/files/downloadCsv/${id}`, {
    responseType: 'blob',
    withCredentials: true
  });
 }

 public requestConsumerMaxtrack() : Observable<any>{
    return this.http.get<JSON>(
      `${this.apiServerUrl}/maxtrack/consumers`,
      { withCredentials: true }
    );
  }

  public insertFindMyCache(list : FindMyCache[]) : Observable<any[]>{
    return this.http.post<any[]>(
      `${this.apiServerUrl}/api/v1/insertFindMyCache`,
       { list },
       { withCredentials: true }
    );
  }

  public insertFindMyCacheLote(list : string[]) : Observable<any[]>{
    return this.http.post<any[]>(
      `${this.apiServerUrl}/api/v1/insertFindMyCacheLote`,
       { list },
       { withCredentials: true }
    );
  }

  public removeFindMyCacheLote(list : string) : Observable<any[]>{
    return this.http.post<any[]>(
      `${this.apiServerUrl}/api/v1/removeFindMyCacheLote`,
       { list },
       { withCredentials: true }
    );
  }

  public searchFindMyCache(list : string) : Observable<any[]>{
    return this.http.post<any[]>(
      `${this.apiServerUrl}/api/v1/searchFindMyCache`,
       { list },
       { withCredentials: true }
    );
  }

}
